var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDislikeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7924",
    "data-name": "Group 7924",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 12.5,
    height: 12.5,
    fill: "#fff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bound-2",
    "data-name": "bound",
    width: 20,
    height: 20,
    rx: 6,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_89",
    "data-name": "Mask Group 89",
    transform: "translate(3.75 3.75)",
    clipPath: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(0 0.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M3.911,3.692H9.079a1.1,1.1,0,0,1,1.028.7l1.718,4.069a1.145,1.145,0,0,1,.078.421v1.16a1.325,1.325,0,0,1-1.136,1.34H7.183l.541,2.449.018.18a.87.87,0,0,1-.25.61l-.6.6L3.1,11.406a1.156,1.156,0,0,1-.33-.814V4.822a1.133,1.133,0,0,1,1.142-1.13Z",
    transform: "translate(0.596 -3.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M25,3.692H23.077v6.731H25Z",
    transform: "translate(-23.077 -3.692)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeWhite);
export default __webpack_public_path__ + "static/media/dislike_white.57aeffc2f7422800a6b0cb6545eb5c9a.svg";
export { ForwardRef as ReactComponent };